import { useEffectOnce } from '@hooks/useEffectOnce';
import { useBrandingStore } from '@stores/branding/stores/branding.store';
import { createContext, ReactNode } from 'react';

interface BrandingContextType {}

// Create context with explicit null default
const BrandingContext = createContext<BrandingContextType | null>(null);

/**
 * Loads branding in the background without blocking app render.
 * The store starts with DEFAULT_BRANDING, so the app can render immediately
 * and components (e.g. AppLogo) get updated when branding finishes loading.
 */
export const BrandingProvider = ({ children }: { children: ReactNode }) => {
  const setBranding = useBrandingStore((state) => state.setBranding);
  const getBranding = useBrandingStore((state) => state.getBranding);

  useEffectOnce(() => {
    getBranding();
  }, []);

  // Listen for branding changes from the editor
  useEffectOnce(() => {
    const handleBrandingChange = (event: CustomEvent) => {
      setBranding(event.detail);
    };

    window.addEventListener(
      'brandingChanged',
      handleBrandingChange as EventListener,
    );
    return () => {
      window.removeEventListener(
        'brandingChanged',
        handleBrandingChange as EventListener,
      );
    };
  }, []);

  return (
    <BrandingContext.Provider value={{}}>{children}</BrandingContext.Provider>
  );
};
